import { Flex, Button, useMantineTheme } from '@mantine/core';
import { IconStack, IconShip, IconTrash, IconArrowBack } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

interface PackageActionBarProps {
    selectedPackages: string[];
    isMobile: boolean;
    onDisposeClick: () => void;
    onReturnClick: () => void;
}

const PackageActionBar = ({
    selectedPackages,
    isMobile,
    onDisposeClick,
    onReturnClick,
}: PackageActionBarProps) => {
    const theme = useMantineTheme();

    // Responsive sizing
    const iconSize = isMobile ? "1rem" : "1rem";
    const buttonSize = isMobile ? "xs" : "md";
    const fontSize = isMobile ? "0.75rem" : "0.875rem";

    const buttonStyle = {
        flex: isMobile ? 1 : 'none',
        minWidth: isMobile ? '0' : 'auto',
        minHeight: isMobile ? '36px' : 'auto',
        fontSize: fontSize,
        padding: isMobile ? '6px 8px' : undefined,
    };

    return (
        <Flex
            gap={isMobile ? "4px" : "md"}
            direction="row"
            justify="center"
            mt="md"
            wrap="wrap"
            style={{
                position: isMobile ? 'sticky' : 'relative',
                bottom: isMobile ? 0 : 'auto',
                background: isMobile ? theme.colors.gray[0] : 'transparent',
                padding: isMobile ? theme.spacing.sm : 0,
                borderTop: isMobile ? `1px solid ${theme.colors.gray[3]}` : 'none',
                zIndex: 100,
                width: '100%',
            }}
        >
            <Button
                variant='filled'
                leftSection={<IconStack size={iconSize} />}
                disabled={selectedPackages.length < 2}
                component={Link}
                to={`/consolidate?packageIds=${selectedPackages.join(',')}`}
                size={buttonSize}
                color="blue"
                style={buttonStyle}
            >
                {isMobile ? 'Combine' : `Consolidate ${selectedPackages.length > 1 ? `(${selectedPackages.length})` : ''}`}
            </Button>

            <Button
                variant="filled"
                leftSection={<IconShip size={iconSize} />}
                disabled={selectedPackages.length !== 1}
                component={Link}
                to={selectedPackages.length === 1
                    ? `/shipments/new?packageId=${selectedPackages[0]}`
                    : '#'
                }
                size={buttonSize}
                color="green"
                style={buttonStyle}
            >
                Ship
            </Button>

            <Button
                variant="filled"
                leftSection={<IconTrash size={iconSize} />}
                disabled={selectedPackages.length === 0}
                onClick={onDisposeClick}
                size={buttonSize}
                color="red"
                style={buttonStyle}
            >
                Dispose
            </Button>

            <Button
                variant="filled"
                leftSection={<IconArrowBack size={iconSize} />}
                disabled={selectedPackages.length === 0}
                onClick={onReturnClick}
                size={buttonSize}
                color="orange"
                style={buttonStyle}
            >
                Return
            </Button>
        </Flex>
    );
};

export default PackageActionBar;
